/**
 * 场地类型枚举
 */
export enum VenueType {
  /** 主会场 */
  MAIN_HALL = 'MAIN_HALL',
  /** 分会场 */
  SUB_HALL = 'SUB_HALL',
  /** 展览区 */
  EXHIBITION = 'EXHIBITION',
  /** 考察路线 */
  TOUR_ROUTE = 'TOUR_ROUTE',
}

/** 所有场地类型值的数组 */
export const VenueTypeValues: string[] = Object.values(VenueType);

/** 场地类型中文标签映射 */
export const VenueTypeLabels: Record<VenueType, string> = {
  [VenueType.MAIN_HALL]: '主会场',
  [VenueType.SUB_HALL]: '分会场',
  [VenueType.EXHIBITION]: '展览区',
  [VenueType.TOUR_ROUTE]: '考察路线',
};
